import {
    Autocomplete,
    Backdrop,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../AppContext";
import { useGetDocTypeList } from "../../shared/hooks/useDocTypesData";
import {
    useGetDocMetadata,
    useSaveDoc,
} from "../../shared/hooks/useFrappeDoctype";
import { uniqueId } from "lodash";

function PosProfileDialog({ open, onClose }) {
    const doctype = "POS Profile";
    const { userInfo, company } = useContext(AppContext);
    const [formData, setFormData] = useState({});
    const [modesOfPayment, setModesOfPayment] = useState([]);

    const [saveLoading, setSaveLoading] = useState(false);

    const permetted = useMemo(() => {
        if (
            userInfo &&
            (["admin", "Admin", "System Manager"].includes(
                userInfo.role_profile_name
            ) ||
                userInfo.name === "Administrator")
        ) {
            return true;
        }
        return false;
    }, [userInfo]);

    const { data: getMeta, isLoading: metaLoading } = useGetDocMetadata(
        permetted ? doctype : null
    );

    const { data: getModesOfPayment } = useGetDocTypeList({
        doctype: "Mode of Payment",
        filters: [["enabled", "=", 1]],
    });

    const saveDoc = useSaveDoc();

    useEffect(() => {
        if (getModesOfPayment) {
            setModesOfPayment(getModesOfPayment);
        }
    }, [getModesOfPayment]);

    useEffect(() => {
        if (getMeta) {
            const _formData = {};
            getMeta.fields
                .filter((i) => i.reqd == 1)
                .map((field) => {
                    _formData[field.fieldname] = field.default || "";
                    if (field.fieldname === "payments") {
                        _formData[field.fieldname] = [];
                    }
                });
            setFormData({ ..._formData, doctype });
        }
    }, [getMeta]);

    const fields = [
        {
            name: "__newname",
            label: "POS Profile Name",
            type: "text",
            required: true,
        },
    ];

    const handleInputChange = (fieldname, value) => {
        if (fieldname === "default_payment") {
            const _formData = { ...formData };

            _formData.payments = _formData.payments.map((mode) => {
                if (mode.mode_of_payment === value) {
                    return { ...mode, default: 1 };
                } else {
                    return { ...mode, default: 0 };
                }
            });

            setFormData(_formData);
        } else {
            setFormData({ ...formData, [fieldname]: value });
        }
    };

    const handleSubmit = () => {
        const submitData = { ...formData };

        submitData.currency = "ILS";
        submitData.__islocal = 1;
        submitData.__unsaved = 1;
        submitData.company = company.name;
        submitData.warehouse = company.default_warehouse;
        submitData.write_off_cost_center = company.cost_center;
        submitData.write_off_account = company.write_off_account;
        submitData.__unsaved = 1;
        submitData.name = `new-pos-profile-${submitData.__newname}`;
        // submitData.__newname = submitData.

        console.log(submitData);

        submitData.payments = submitData.payments.map((mode) => {
            return {
                ...mode,
                doctype: "POS Payment Method",
                parentfield: "payments",
                parenttype: "POS Profile",
                __islocal: 1,
                __unsaved: 1,
                name: `new-pos-payment-method-${uniqueId()}`,
                parent: `new-pos-profile-${submitData.__newname}`,
            };
        });

        setSaveLoading(true);

        saveDoc.mutate(
            {
                payload: submitData,
                action: "Save",
            },
            {
                onSuccess: () => {
                    onClose();
                },
                onError: () => {},
                onSettled: () => {
                    setSaveLoading(false);
                },
            }
        );

        console.log(formData);
    };

    return (
        <Backdrop
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
                position: "absolute",
                backgroundColor: "rgba(33, 43, 54, 0.75)",
            }}
            open={open}
        >
            <Dialog open={open}>
                <DialogTitle>Pos Profile</DialogTitle>
                <DialogContent>
                    {permetted ? (
                        <>
                            <Box component="form" noValidate>
                                {fields.map((field) => (
                                    <TextField
                                        key={`PosProfileField-${field.name}`}
                                        margin="normal"
                                        label={field.label}
                                        type={field.type}
                                        fullWidth
                                        required={field.required}
                                        onChange={(e, value) => {
                                            handleInputChange(
                                                field.name,
                                                e.target.value
                                            );
                                        }}
                                    />
                                ))}
                                <Autocomplete
                                    multiple
                                    options={modesOfPayment.map(
                                        (mode) => mode.name
                                    )}
                                    onChange={(e, value) => {
                                        handleInputChange(
                                            "payments",
                                            value.map((val) => ({
                                                mode_of_payment: val,
                                            }))
                                        );
                                    }}
                                    disableCloseOnSelect={true}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            margin="normal"
                                            label="Payment Methods"
                                            fullWidth
                                        />
                                    )}
                                />

                                <Autocomplete
                                    options={
                                        formData.payments
                                            ? formData.payments.map(
                                                  (mode) => mode.mode_of_payment
                                              )
                                            : []
                                    }
                                    onChange={(e, value) => {
                                        handleInputChange(
                                            "default_payment",
                                            value
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            margin="normal"
                                            label="Default Payment Method"
                                            fullWidth
                                        />
                                    )}
                                />

                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    disabled={saveLoading}
                                >
                                    {saveLoading ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        "Submit"
                                    )}
                                </Button>
                            </Box>
                        </>
                    ) : (
                        <>
                            <DialogContentText>
                                Please Contact System Admin or Restaurant
                                Manager to open the POS Profile
                            </DialogContentText>
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </Backdrop>
    );
}

export default PosProfileDialog;
